export default __webpack_public_path__ + "static/media/05.c10e7934.jpg";